export default {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:1337',
  ENVIRONMENT: process.env.NODE_ENV,
};
